import { IBetLeader } from '../../../../redux/reducers/topBets';
import { ITopAnnouncementBetModel } from '../../../../repositories/auction/entities/Models/TopAnnouncementBetModel';

export function mapBetLeaders(topBets: ITopAnnouncementBetModel[]): IBetLeader[] {
  return topBets
    .sort((a, b) => a.auctionPlace - b.auctionPlace)
    .map(({ announcementBet, auctionPlace, companies }) => ({
      bet: announcementBet,
      auctionPlace,
      companies,
    }));
}
